/**
 * WSH SEO Accordion v6 — Heritage Refined
 * Enhances native <details>/<summary> with:
 * - Chevron toggle (＋ / −)
 * - Smooth height animation (respects reduced-motion)
 * - Subhead fade-in on open
 * - TOC pill scroll-to + open
 * - Horizon re-render subscription (idempotent)
 */
(function () {
  'use strict';

  var INIT_FLAG = 'data-wsh-accordion-init';
  var CHEVRON_CLOSED = '\uFF0B'; // ＋
  var CHEVRON_OPEN = '\uFF0D';   // −
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initAccordion(root) {
    if (!root || root.getAttribute(INIT_FLAG) === '1') return;
    root.setAttribute(INIT_FLAG, '1');

    var cards = root.querySelectorAll('.wsh-seo-card');
    var tocPills = root.querySelectorAll('.wsh-seo-toc-pill');

    // ── Chevron + subhead sync on toggle ──
    cards.forEach(function (card) {
      var chevron = card.querySelector('.wsh-chevron');
      var subhead = card.querySelector('.wsh-subhead');

      // Set initial chevron state
      if (chevron) {
        chevron.textContent = card.open ? CHEVRON_OPEN : CHEVRON_CLOSED;
      }

      card.addEventListener('toggle', function () {
        if (chevron) {
          chevron.textContent = card.open ? CHEVRON_OPEN : CHEVRON_CLOSED;
        }

        // Subhead fade-in on open
        if (subhead && card.open && !prefersReducedMotion.matches) {
          subhead.style.opacity = '0';
          subhead.style.transition = 'opacity 200ms ease';
          requestAnimationFrame(function () {
            subhead.style.opacity = '1';
          });
        }
      });
    });

    // ── TOC pill → scroll to card + open ──
    tocPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = pill.getAttribute('data-target-card');
        if (idx === null) return;

        var allCards = root.querySelectorAll('.wsh-seo-card');
        var target = allCards[parseInt(idx, 10)];
        if (!target) return;

        // Open the card if closed
        if (!target.open) {
          target.open = true;
        }

        // Smooth scroll
        target.scrollIntoView({
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  }

  // ── Initial bind ──
  function initAll() {
    document.querySelectorAll('.wsh-seo-accordion').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // ── Horizon section re-render subscription ──
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.wsh-seo-accordion');
    if (section) {
      section.removeAttribute(INIT_FLAG);
      initAccordion(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.wsh-seo-accordion');
    if (section) {
      section.removeAttribute(INIT_FLAG);
    }
  });
})();
